import {IUser} from './user';

export enum Priority {
    LOW = 'Low',
    MEDIUM = 'Medium',
    HIGH = 'High',
}

export interface INotification {
    _id?: string;
    heading: string;
    createdAt: Date;
    title: string;
    priority: Priority;
    targetUser: IUser;
    seen?: boolean;
    url?: string;
    system?: boolean;
}

export type INotificationCreate = Omit<INotification, '_id'>;

export interface INotificationTable extends Pick<INotification, 'title'> {
    _id: string;
}

export function highPriotiyNotification(heading: string, title: string, targetUser: IUser): INotificationCreate {
    return {
        heading,
        title,
        targetUser,
        priority: Priority.HIGH,
        createdAt: new Date(),
    };
}

export function mediumPriotiyNotification(heading: string, title: string, targetUser: IUser): INotificationCreate {
    return {
        heading,
        title,
        targetUser,
        priority: Priority.MEDIUM,
        createdAt: new Date(),
    };
}
